import { Appear, Flex, Icon, Link, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';

type Props = { failing: boolean; onFetch: () => void };

const MessageFailing: FunctionComponent<Props> = (props) => {
  const { failing, onFetch } = props;

  return (
    <Appear
      absolute
      animation="Fade"
      style={{ pointerEvents: failing ? undefined : 'none' }}
      textColor="red-3"
      visible={failing}
    >
      <Flex alignChildren="middle" direction="vertical" height="100%">
        <Flex>
          <Flex alignChildren="middle" direction="vertical">
            <Icon margin="x1" name="BitbotFailed" />
          </Flex>
          <Text align="middle" ellipsis size="x2">
            Uh oh, there&apos;s been a problem.
          </Text>
          <Text align="middle" size="x2">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link clickable onClick={onFetch} underline>
              Click here to retry
            </Link>
            .
          </Text>
        </Flex>
      </Flex>
    </Appear>
  );
};

export default MessageFailing;
